import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CallToAction } from '../components/CallToAction';

export const Unternehmen = () => {
  const { t } = useTranslation();

  const highlights = [
    { key: 'contact' },
    { key: 'regional' },
    { key: 'quality' }
  ];

  const focusAreas = [
    { key: 'installation' },
    { key: 'lighting' },
    { key: 'renovation' },
    { key: 'network' },
    { key: 'security' },
    { key: 'infrared' }
  ];

  return (
    <>
      <section className="page-hero" id="top">
        <div className="container page-hero__inner">
          <div>
            <span className="section__eyebrow">{t('companyPage.hero.eyebrow')}</span>
            <h1>{t('companyPage.hero.title')}</h1>
            <p className="page-hero__lead">{t('companyPage.hero.lead')}</p>
          </div>
          <Link className="btn btn--primary" to="/kontakt">
            {t('companyPage.hero.cta')}
          </Link>
        </div>
      </section>

      <section className="section section--split">
        <div className="container section__split">
          <div className="split__media" role="presentation" aria-hidden="true">
            <div className="split__overlay" />
          </div>
          <div className="split__content">
            <span className="section__eyebrow">{t('companyPage.workflow.eyebrow')}</span>
            <h2>{t('companyPage.workflow.title')}</h2>
            <p>{t('companyPage.workflow.textOne')}</p>
            <p>{t('companyPage.workflow.textTwo')}</p>
            <div className="pill-list">
              {focusAreas.map((item) => (
                <span key={item.key}>{t(`companyPage.workflow.pills.${item.key}`)}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container grid grid--services">
          {highlights.map((item) => (
            <article className="card" key={item.key}>
              <h3>{t(`companyPage.highlights.${item.key}.title`)}</h3>
              <p>{t(`companyPage.highlights.${item.key}.text`)}</p>
            </article>
          ))}
        </div>
      </section>

      <CallToAction
        title={t('companyPage.cta.title')}
        description={t('companyPage.cta.description')}
        ctaLabel={t('companyPage.cta.button')}
        ctaTo="/kontakt"
      />
    </>
  );
};
